import { render, staticRenderFns } from "./UserShowComponent.vue?vue&type=template&id=2e184cf4"
import script from "./UserShowComponent.vue?vue&type=script&lang=js"
export * from "./UserShowComponent.vue?vue&type=script&lang=js"
import style0 from "./UserShowComponent.vue?vue&type=style&index=0&id=2e184cf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports